<template>
    <teleport :to="props.to" v-if="props.to">
        <slot />
    </teleport>
    <slot v-else />
</template>

<script setup lang="ts">

const props = defineProps<{
    to: HTMLElement | null;
}>();

</script>

<style lang="scss" scoped>

</style>
